

const calcPercent = (actual: number, base: number): number => {
    if (base === 0) return 0
    return ((actual - base) / Math.abs(base)) * 100
}

export default calcPercent

